import { UserAvatar } from "@/components/user/UserAvatar"
import { InlineEditableBooleanProperty } from "../../components/form/InlineEditableBooleanProperty"
import { InlineEditableProperty } from "../../components/form/InlineEditableProperty"
import { QueryRender } from "../../components/helpers/QueryRender"
import { firstNameSchema, lastNameSchema, phoneSchema } from "../../entities/user/user"
import { useUpdateUser } from "../../entities/user/useUser"
import { uploadPhoto } from "../../firebase/storage"
import { useAuth } from "../../hooks/useAuth"
import { formatPhoneNumber } from "@/utils/formatPhoneNumber"
import { useProcess } from "@/contexts/ProcessContext"

export default function Settings() {
   const { user, ...query } = useAuth()
   const updateUser = useUpdateUser()
   const { startProcess } = useProcess()


   const handlePhotoChange = async (file: File) => {
      if (!user) return
      startProcess(async () => {
         const photoUrl = await uploadPhoto(file)
         await updateUser(user.id, { photo: photoUrl }, { quickMode: true })
      })
   }

   const handlePropertySave = async (field: string, value: string) => {
      if (!user) return
      await updateUser(user.id, { [field]: value })
   }

   const handleNotificationChange = async (type: "email" | "sms") => {
      if (!user) return
      await updateUser(user.id, {
         notificationPreferences: {
            ...user.notificationPreferences,
            [type]: !user.notificationPreferences[type],
         },
      })
   }

   return (
      <div className="page-section max-w-xl">
         <h1 className="title">Paramètres</h1>
         <QueryRender query={query} data={user} emptyMessage="Utilisateur non trouvé">
            {(user) => (
               <div className=" ">
                  <div className=" ">
                     <div className="flex items-center space-x-4">
                        <UserAvatar
                           photo={user.photo}
                           name={`${user.firstName} ${user.lastName}`}
                           size="xl"
                           editable
                           onPhotoChange={handlePhotoChange}
                        />
                     </div>

                     <InlineEditableProperty
                        label="Email"
                        value={user?.email}
                        field="email"
                        editable={false}
                     />

                     <InlineEditableProperty
                        label="Prénom"
                        value={user?.firstName}
                        field="firstName"
                        schema={firstNameSchema}
                        onSave={handlePropertySave}
                     />

                     <InlineEditableProperty
                        label="Nom"
                        value={user?.lastName}
                        field="lastName"
                        schema={lastNameSchema}
                        onSave={handlePropertySave}
                     />

                     <InlineEditableProperty
                        label="Téléphone"
                        value={user?.phone}
                        field="phone"
                        formatDisplayedValue={formatPhoneNumber}
                        schema={phoneSchema}
                        onSave={handlePropertySave}
                     />

                     <div className="divider">Préférences de notification</div>
                     <div className="flex flex-col gap-2">
                        <InlineEditableBooleanProperty
                           label="Notifications par email"
                           value={user?.notificationPreferences?.email}
                           field="email"
                           onSave={(field) => handleNotificationChange(field as "email" | "sms")}
                        />
                        <InlineEditableBooleanProperty
                           label="Notifications par SMS"
                           value={user?.notificationPreferences?.sms}
                           field="sms"
                           onSave={(field) => handleNotificationChange(field as "email" | "sms")}
                        />
                     </div>
                  </div>
               </div>
            )}
         </QueryRender>
      </div>
   )
}
